export default "__VITE_ASSET__BKBwvqQE__"